module.exports = __webpack_public_path__ + "static/media/CursorArrow.d784c3c5.svg";